<template>
    <div ref="footer" :class="[$vClass(), { '--sticky': sticking }]">
        <slot></slot>
    </div>
</template>

<script>

export default {
  name: 'sticky-card-footer',
  nameClassStyle: 'sticky-card-footer',
  data() {
    return {
      sticking: false,
      observer: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        // Get element where there is content loaded
        const elContainer = document.getElementById('layout-body');
        if (this.$refs.footer) {
          this.observer = new IntersectionObserver(
            ([entry]) => {
              // Check if there is scrolling on 'layout-body'
              let hasScrollHeight = true;
              if (elContainer) {
                // Compare if 'layout body' is more big than inner window
                hasScrollHeight = window.innerHeight < elContainer.clientHeight;
              }
              this.sticking = hasScrollHeight && !entry.isIntersecting;
            },
            {
              threshold: 0.0,
              rootMargin: `0px 0px -${this.$refs.footer.clientHeight}px 0px`,
            },
          );
          this.observer.observe(this.$refs.footer);
        }
      }, 1000);
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
};
</script>

<style scoped lang="scss">
.sticky-card-footer {
    position: sticky;
    bottom: 0;
    z-index: 10;
    background-color: white;
    padding: 20px;
    margin: -20px;

    &.--sticky {
      box-shadow: rgba(0, 0, 0, 0.1) 0px -5px 12px 0px;
      clip-path: inset(-20px 0px 0px 0px);
      z-index: 10;
    }
}
</style>
